<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="订单号" name="sub_order_number" placeholder="代理间流转订单号"></c-form-item>
                    <c-form-item type="checkbox" label="订单状态" name="state" :options="state" ></c-form-item>
                    <c-form-item type="select" label="代理商等级" name="user_level3" options="USER_LEVEL_AUTH"></c-form-item>
					<c-form-item type="input" label="代理商手机" name="agency_user_manage_mobilephone" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="代理商昵称" name="agency_user_nick_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="select" label="采购人等级" name="user_level2" options="USER_LEVEL_AUTH"></c-form-item>
					<c-form-item type="input" label="采购人手机" name="order_user_manage_mobilephone" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="采购人昵称" name="order_user_nick_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="终端订单号" name="order_number" placeholder="原始下单订单号"></c-form-item>
					<c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
                <c-button power="b_sub_order_export" color="m" hollow @click="syncExport()">导出订单</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>

			<c-table ref="table">
				<c-table-column type="selector"></c-table-column>
				
				<c-table-column
					label="订单号"
					name="sub_order_number"
					width="120"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/sub_order/${data.sub_order_number}`)">{{data.sub_order_number}}</a>
					</template>
				</c-table-column>

				<c-table-column
					label="订单来源"
					name="order_source"
					width="75"
				>
					<template v-slot="{data}">
						{{orderSourceName[data.order_source]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单状态"
					name="state"
					width="75"
				>
					<template v-slot="{data}">
						<span v-if="data.state == -1" style="color:red">审批驳回</span>
						<span v-if="data.state == 0" style="color:darkgray">待付款</span>
                        <span v-if="data.state == 1" style="color:brown">待审批</span>
                        <span v-if="data.state == 2" style="color:green">已审批</span>
                        <span v-if="data.state == 6" style="color:red">订单关闭</span>
                    </template>
				</c-table-column>

				<c-table-column
					label="处理方式"
					name="deal_mode"
					width="75"
				>
					<template v-slot="{data}">
                        <span v-if="data.agency_user_id != -2 && data.deal_mode == 1" style="color:green">云仓发货</span>
                        <span v-else-if="data.agency_user_id != -2 && data.deal_mode == 2" style="color:brown">上级发货</span>
                        <span v-else-if="data.agency_user_id != -2 && data.deal_mode == 3" style="color:darkred">自行发货</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="代理商头像/昵称"
					name="agency_nick_name"
					width="200"
				>
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.agency_user_id != -2">
                            <c-image :src="data.agency_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.agency_nick_name||'--'}}</span>
                        </div>
                        <span v-else style="color: red"><strong>平台</strong></span>
                    </template>
				</c-table-column>
				
				<c-table-column
					label="代理商等级"
					name="agency_level_name"
					width="90"
				>
					<template v-slot="{data}">
						<div v-if="data.agency_user_id != -2">
							<span v-if="data.agency_level_name && data.agency_level_name!='普通会员'" style="color:blue">{{data.agency_level_name}}</span>
							<span v-else >{{data.agency_level_name}}</span>
						</div>
						<span v-else >-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="代理商手机号"
					name="agency_user_manage_mobilephone"
					width="105"
				>
					<template v-slot="{data}">
						<span v-if="data.agency_user_manage_mobilephone">{{data.agency_user_manage_mobilephone}}</span>
						<span v-else style="color:#999">-</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="采购人头像/昵称"
					name="order_nick_name"
					width="220"
				>
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.order_head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.order_nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>
				
                <c-table-column
                  label="采购人等级"
                  name="order_level_name"
                  width="90"
                >
                    <template v-slot="{data}">
                        <span v-if="data.order_level_name && data.order_level_name!='普通会员'" style="color:blue">{{data.order_level_name}}</span>
                        <span v-else >{{data.order_level_name}}</span>
                    </template>
                </c-table-column>
				
                <c-table-column
                  label="采购人手机号"
                  name="order_user_manage_mobilephone"
                  width="105"
                >
                </c-table-column>
<!--
                <c-table-column
                    label="订单运费"
                    name="logistics_money"
                    width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.logistics_money">￥{{(data.logistics_money||0).toFixed(2)}}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>-->

				<c-table-column
					label="采购金额"
					name="product_money"
					width="110"
				>
				    <template v-slot="{data}">
                        <span>￥{{(data.product_money||0).toFixed(2)}}</span>
				    </template>
				</c-table-column>

				<c-table-column
					label="代理金额"
					name="product_money_dl"
					width="110"
				>
				    <template v-slot="{data}">
                        <span>￥{{(data.product_money_dl||0).toFixed(2)}}</span>
				    </template>
				</c-table-column>

				<c-table-column
					label="终端订单号"
					name="order_number"
					width="120"
				>
				</c-table-column>

                <c-table-column
                    label="下单时间"
                    name="create_date"
                    width="150"
                ></c-table-column>

                <c-table-column
                    label="支付时间"
                    name="payment_date"
                    width="150"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="80"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_sub_order_deal" v-if="data.agency_user_id != -2 && data.state == 1" @click="handleSubOrder(data)">审核</c-table-button>
                    </template>
                </c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'm_sub_order',

        computed: {
            ...mapState(['systemConfig', 'userInfo'])

        },

        props: {
        },

        data() {
			return {
                workType:27,
                searchParams:{},
                orderSourceName: {
                    'OMS':'管理后台',
                    'IOS': '苹果',
                    'ANDROID': '安卓',
                    'MINI': '小程序',
                    'PC': 'PC电脑'
                },
                state:[
                    {name: '待付款',value: '0'},
                    {name: '待审核',value: '1'},
                    {name: '已审核',value: '2'},
                    {name: '审批驳回',value: '-1'},
                    {name: '订单关闭',value: '6'}
                ],
				defaultSearch: {}
			}
		},

        watch: {
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('subOrder.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
            //搜索
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/sub/order/list',
                    data
                });
                this.searchParams = data;
            },
            //审核子单
            handleSubOrder(data) {
                this.$confirm({
                    text: `确定要处理订单【`+data.sub_order_number+`】，将其处理方法修改为“上级发货”？`,
                    resolve: () => {
                        this.request({
                            url: '/sub/order/deal',
                            data: {
                                sub_order_number:data.sub_order_number
                            },
                            loading: true,
                            success: () => {
                                //刷新列表
                                this.$nextTick(() => {
                                    this.$refs.search.search();
                                })
                            }
                        });
                    }
                });
            },
            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            }
        }
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>